export default {

    checkboxContainer: {
        background: "#215daa",
        height: "20px",
        position: "relative",
        width: "20px",
        minWidth: "20px",
        borderRadius: "1px",
    },

    checkBoxInput: {
        opacity: 0,
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1,
        cursor: "pointer",
    },

    disabledCheckedStyle: {
        background: "#b3cdee",
    }
}